// src/App.tsx
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./styles/globals.css";
import NewTicketView from "./Components/NewTicketView";
import DashboardView from "./Components/DashboardView";
import TicketDetailView from "./Components/TicketDetailView";
import UserDashboardView from "./Components/UserDashboard";
import AdminView from "./Components/AdminView";
import TicketDetailViewSupport from "./Components/TicketDetailViewSupport";
import { useAuth } from "react-oidc-context";
import { fetchMemberBySentence } from "./api";
import { createContext, SetStateAction, useEffect, useState } from "react";
import { User } from "./types";
import AddOrEditFaultView from "./Components/AddOrEditFaultView";
import { AlertModal, AlertModalContext } from "./Components/AlertModal";
import AddOrEditFAQView from "./Components/AddOrEditFAQView";

export const GlobalContext = createContext({
  globalSite: "",
  setSite: (_value: string) => {},
  ticketFilter: "Requested",
  setTicketFilter: (_value: SetStateAction<"Requested" | "Closed" | "InProgress" | "EscalatedToUnify">) => {}
});

function App() {
  const auth = useAuth();
  const [member, setMember] = useState<User>();
  const [role, setRole] = useState("prisoner");
  const [site, setSite] = useState("");
  const [ticketFilter, setTicketFilter] = useState<"Requested" | "Closed" | "InProgress" | "EscalatedToUnify">("Requested");

  useEffect(() => {
    if (!auth.isLoading) {
      if (!auth.isAuthenticated) {
        auth.signinRedirect();
        if (auth.user?.profile.sentence !== undefined) {
          setSite(String(auth.user?.profile.sentence))
        }
      }
    }
  }, [auth.isAuthenticated, auth.isLoading])

  // alert modal state
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const role = String(auth.user?.profile.role)
    setRole(role);
  }, [auth.user?.profile.role])

  useEffect(() => {
    var userSentence = auth.user?.profile.sentence
    // userSentence = "DSD234"
    if (userSentence !== undefined) {
      fetchMemberBySentence(String(userSentence))
      .then((data) => {
        if (data.id !== undefined)
          setMember(data)
      })
      .catch((err) => console.error("Error fetching member:", err))
    }
  }, [auth.user])

  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in ...</div>;
    case "signoutRedirect":
      return <div>Signing you out ...</div>;
  }

  if (auth.isLoading) {
    return <div>Loading ...</div>
  }

  if (auth.error) {
    return <div>Oops ... {auth.error.message}</div>
  }

  function nav() {
    if (role === "staff" || role === "super") {
      return (
        <nav style={{ padding: 16, textAlign: "center" }}>
          <Link to={`/dashboard/${site}`}>Tickets</Link> | {" "}
          <Link to={`/admin/${site}`}>Staff</Link>
        </nav>
      )
    }
    if (member) {
      return (
        <nav style={{ padding: 16, textAlign: "center" }}>
          <Link to={`/dashboard/${site}`}>Tickets</Link>
        </nav>
      )
    }
    return (
      <nav style={{ padding: 16, textAlign: "center" }}>
        <Link to="/">Home</Link>
      </nav>
    )
  }

  function defaultRoute() {
    if (role === "staff" || role === "super") {
      return (<Route path="/" element={<AdminView />} />)
    }
    else if (member) {
      return (<Route path="/" element={<DashboardView />} />)
    }
    return (<Route path="/" element={<UserDashboardView />} />)
  }

  if (auth.isAuthenticated) {
    return (
      <BrowserRouter>
        <AlertModalContext value={{
          setShowAlertModal: setShowAlert,
          setAlertMessage: setMessage
        }}>
          <GlobalContext value={{
            globalSite: site,
            setSite,
            ticketFilter,
            setTicketFilter
          }}>
            {nav()}
            <Routes>
              {defaultRoute()}
              <Route path="/new-ticket" element={<NewTicketView />} />
              <Route path="/dashboard/:site" element={<DashboardView />} />
              <Route path="/dashboard/:site/support/:id" element={<TicketDetailViewSupport />} />
              <Route path="/dashboard/:site/:id" element={<TicketDetailView />} />
              <Route path="/admin/:site" element={<AdminView />} />
              <Route path="/admin/:site/faults/new" element={<AddOrEditFaultView />}/>
              <Route path="/admin/:site/faults/:id/edit" element={<AddOrEditFaultView />}/>
              <Route path="/admin/:site/faq/new" element={<AddOrEditFAQView />}/>
              <Route path="/admin/:site/faq/:id/edit" element={<AddOrEditFAQView />}/>
            </Routes>
          </GlobalContext>
          <AlertModal {...{showModal: showAlert, setShowModal: setShowAlert, text: message, setText: setMessage}}/>
        </AlertModalContext>
      </BrowserRouter>
    )
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <button
        onClick={() => auth.signinRedirect()}
        style={{
          padding: "12px 32px",
          fontSize: "1.2rem",
          borderRadius: "8px",
          border: "none",
          background: "#2563eb",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          transition: "background 0.2s"
        }}
      >
        Start
      </button>
    </div>
  )
}

export default App;
